module.exports = __webpack_public_path__ + "static/cover-729a09dbc1f79cd96a69c7c3ad8a2ed6.jpg";